// extracted by mini-css-extract-plugin
module.exports = {"titleSpace":"policy-module--titleSpace--2hViq"};